/**
 * Where the HTTP layer gets the bearer token from. `shared` can't import the
 * auth feature, so auth registers its provider here when it starts.
 */
type AccessTokenProvider = () => string | null

let provider: AccessTokenProvider = () => null

export const setAccessTokenProvider = (next: AccessTokenProvider) => {
  provider = next
}

export const getAccessToken = (): string | null => provider()
